import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noSections: {
    id: '9iKeSE',
    description: 'Label shown when no sections are selected in the visibility selector',
    defaultMessage: 'No Sections',
  },
  allSections: {
    id: 'vn16SR',
    description: 'Label shown when all sections are selected in the visibility selector',
    defaultMessage: 'All Sections',
  },
  sectionCount: {
    id: 'hKfAEF',
    description: 'Label showing how many sections are selected out of the total in the visibility selector',
    defaultMessage: '{selectedCount} of {totalCount} Sections',
  },
  rateCardReadOnlySectionTitle: {
    id: '3ro2B0',
    description: 'Title for the rate card read-only section showing shipped labels',
    defaultMessage: 'Shipped Labels',
  },
  sectionHiddenPlaceholder: {
    id: 'qYZPex',
    description: 'Placeholder text shown when a section is hidden but visible during customize mode',
    defaultMessage: 'This section is hidden for the current order',
  },
  columnLayoutLabel: {
    description: 'aria label for the column layout selector',
    defaultMessage: '{layout} column layout',
    id: 'qo8VfN',
  },
  emptyColumnPlaceholder: {
    id: 'KHg+nk',
    description: 'text shown for a placeholder value in an empty column',
    defaultMessage: 'Drop sections here',
  },
});
